//
//
//
//

export default {
  name: 'UiDocumentIcon',
  props: {
    label: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      validator: type => ['gray-light', 'gray'].includes(type),
    },
  },
  computed: {
    colors() {
      if (this.theme === 'gray-light') {
        return {
          bodyColor: '#E7E8F1',
          cornerColor: '#D1D3E0',
          textColor: '#000'
        };
      }
      if (this.theme === 'gray') {
        return {
          bodyColor: '#D1D3E0',
          cornerColor: '#7B7D8E',
          textColor: '#000'
        };
      }

      return {
        bodyColor: '#ACDCFF',
        cornerColor: '#85BCE4',
        textColor: '#000'
      };
    },
  },
}
